<template>
  <LoadingBar v-if="error.message.length" :error="error.message"></LoadingBar>
  <Page v-else title="Browse Report Recipients">
    <v-form>
      <v-row>
        <v-col cols="8">
          <v-text-field
            v-model.trim="options.params.search"
            @keydown.enter.prevent
            label="Search"
            @click:clear="clearInputs"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-radio-group v-model="show">
            <v-row>
              <v-col>
                <v-radio label="Show Active" value="active"></v-radio>
              </v-col>
              <v-col>
                <v-radio label="Show All" value="all"></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-form>
    <v-data-table
      :headers="this.headers"
      :options.sync="tableOptions"
      v-bind="customAttrs"
      item-key="id"
      no-data-text="You have no Report Recipients."
      no-results-text="No matching Report Recipients"
      :footer-props="{
        pageText: 'Navigate Pages',
        itemsPerPageOptions: [5, 15, 30, 50, 100]
      }"
    >
      <template v-slot:item.actions="{ item }">
        <span v-if="item.is_active">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleActivation(item)" v-bind="attrs" v-on="on"
                >mdi-cancel</v-icon
              >
            </template>
            <span>Deactivate Report Recipient</span>
          </v-tooltip>
        </span>
        <span v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleActivation(item)" v-bind="attrs" v-on="on"
                >mdi-check</v-icon
              >
            </template>
            <span>Activate Report Recipient</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.setup="{ item }">
        <v-icon v-if="!item.o_user_id" color="orange"
          >mdi-dots-horizontal</v-icon
        >
        <v-icon v-if="!!item.o_user_id" color="green">mdi-check</v-icon>
        {{ !!item.o_user_id ? "Complete" : "Pending" }}
      </template>
      <template v-slot:item.is_active="{ item }">
        <v-icon v-if="item.is_active" color="green">mdi-check</v-icon>
        {{ item.is_active ? "Active" : "Inactive" }}
      </template>
    </v-data-table>
    <v-btn color="primary" @click="invite">Invite New Report Recipient</v-btn>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import { mapActions, mapState, mapGetters } from "vuex";
import dataTablePagination from "@/mixins/dataTablePagination";
export default {
  name: "CopyToBrowse",
  mixins: [dataTablePagination],
  components: { Page },
  data() {
    return {
      loading: false,
      show: "active",
      search: "",
      error: {
        message: ""
      },
      hasFetched: false,
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Last Name", value: "last_name" },
        { text: "Business Name", value: "business_name" },
        { text: "Email", value: "email" },
        { text: "Setup", value: "setup" },
        { text: "Status", value: "is_active" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      options: {
        params: {
          search: "",
          client_id: null,
          page: 1,
          is_active: 1,
          itemsPerPage: 15
        }
      },
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
        sortBy: [],
        sortDesc: []
      }
    };
  },
  computed: {
    ...mapGetters("clients", ["selectedClient"]),
    ...mapState("copyTo", { copyTos: "items" }),
    ...mapState("auth", ["user"]),
    customAttrs() {
      return {
        ...this.defaultAttrs,
        items: this.items
      };
    },
    defaultAttrs() {
      return {
        items: this.items,
        headers: this.headers,
        loading: this.loading,
        "footer-props": { "items-per-page-options": [5, 15, 30, 50, 100] },
        "server-items-length": this.total
      };
    }
  },
  methods: {
    ...mapActions("copyTo", ["getPaginated", "editCopyTo"]),
    toggleActivation(item) {
      this.loading = true;
      this.editCopyTo({
        uuid: item.uuid,
        is_active: !item.is_active
      }).then(() => {
        this.getPaginatedDebounced();
      });
    },
    invite() {
      this.$router.push("/copy-to/add");
    },
    clearInputs() {
      this.options.params.search = "";
    },
    fetchCopyTos() {
      if (this.selectedClient && this.selectedClient.id) {
        this.options.params.client_id = this.selectedClient.id;
        this.getPaginated(this.options);
        this.hasFetched = true;
      }
    }
  },
  mounted() {
    if (this.user.is_copy_to) {
      this.error.message = "Report Recipient has no access to this page";
      return;
    }
    if (this.selectedClient && this.selectedClient.id && !this.hasFetched) {
      this.fetchCopyTos();
    }
  },
  created() {
    if (this.selectedClient) {
      this.options.params.client_id = this.selectedClient.id;
    }
  },
  watch: {
    tableOptions: {
      handler(newVal) {
        this.options.itemsPerPage = newVal.itemsPerPage;
        this.options.page = newVal.page;
      },
      deep: true
    },
    selectedClient(newVal) {
      this.options.params.client_id = newVal?.id || null;
    },
    show(value) {
      this.options.params.is_active = value === "active" ? 1 : "";
    }
  }
};
</script>

<style scoped></style>
